import { render } from "./detallesreserva.vue?vue&type=template&id=1db3c2fa&scoped=true"
import script from "./detallesreserva.vue?vue&type=script&lang=js"
export * from "./detallesreserva.vue?vue&type=script&lang=js"

import "./detallesreserva.vue?vue&type=style&index=0&id=1db3c2fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db3c2fa"]])

export default __exports__